@if (initialized) {
  <app-global-layout>
    <router-outlet />
  </app-global-layout>

  <!-- overlays/ modals/ toasts/ notifications etc. -->
  <p-confirmdialog />
  <p-toast [life]="4000" />
  <ag-notifications-and-alerts />
  <ag-discard-confirmation-modal
    [(visible)]="discardService.visible"
    [title]="discardService.title()"
    [body]="discardService.body()"
    (confirmed)="discardService.confirm()"
    (cancelled)="discardService.cancel()"
  />
}
<ng-template agModalHost />
